import React from "react"
import { Editor } from "react-draft-wysiwyg"
import styled from "styled-components"
import FormInput from "../components/FormInput"
import ImageInputBtn from "../components/ImageInputBtn"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

const EditorComp = ({
  handleHeadingChange,
  handleThumbnailSelect,
  handleDescriptionChange,
  description,
  heading,
  inputLabel,
  txtAreaName,
  inpName,
  thumbnailSource,
  editorState,
  handleEditorChange,
  defaultState
}) => {
  const editorStyle = {
    height: "20rem",
    padding: "1rem",
    border: "1.3px solid #3a3a3a",
    borderRadius: "5px",
  }

  return (
    <EditorWrap>
      <FormInput
        inpName={inpName}
        label={inputLabel}
        value={heading}
        handleOnChange={handleHeadingChange}
      />
      <div className="thumbnailCont">
        {thumbnailSource ? (
          <img src={thumbnailSource} alt="" className="thumbnail" />
        ) : (
          <input
            type="file"
            onChange={handleThumbnailSelect}
            className="thumbnail"
            name="thumbnail"
            title={"Select image"}
          />
        )}
      </div>
      <label htmlFor="description">Description</label>
      <Editor
        defaultContentState={defaultState}
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        editorStyle={editorStyle}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        toolbar={{
          options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
          inline: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          link: { inDropdown: true },
         
        }}
      />
    </EditorWrap>
  )
}

export default EditorComp

const EditorWrap = styled.form`
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 0.5rem;
  margin-top: 0.5rem;
  background: ${({ theme }) => theme.background};
  .description {
    background: ${({ theme }) => theme.background};

    border: 1px solid rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    border-radius: 6px;
    height: 8rem;
    padding: 1rem 0.5rem;
    color: ${({ theme }) => theme.text};
    transition: 0.2s ease all;
    :focus {
      outline: ${({ theme }) => theme.accent} solid 2px;
      box-shadow: 0px 0px 15px -5px rgba(224, 20, 13, 1);
    }
  }
  .thumbnailCont {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 10rem;
    margin: 0.5rem 0;
    background: ${({ theme }) => theme.body};
  }
  .thumbnail {
    width: 90%;
    height: 5rem;
    object-fit: cover;
  }

  .toolbarClassName {
    background:  ${({ theme }) => theme.body};
    color:  ${({ theme }) => theme.text};
    
    .rdw-dropdown-selectedtext span  {
      color:  ${({ theme }) => theme.text};
    }
  }
`
